__turbopack_context__.v({
  "loader": "styles-module-scss-module__5oF8sW__loader",
  "spinner": "styles-module-scss-module__5oF8sW__spinner",
});
